module.exports = __webpack_public_path__ + "img/4_1.a7fd7d88.png";